import React, { useEffect, useState } from "react";
import { Activity, ArrowRight, Filter, MapPin, Plus, Search, Store } from "lucide-react";
import { Link } from "react-router-dom";
import { api } from "../api";

const labels = { draft: "Draft", open: "Open", paused: "Paused", closed: "Closed" };
const Pill = ({ value }) => <span className={"pill " + value}>{labels[value] || value}</span>;
const Banner = ({ children, tone = "info" }) => <div className={"banner " + tone}>{children}</div>;

function Events() {
  const [events, setEvents] = useState([]);
  const [error, setError] = useState("");
  const [query, setQuery] = useState("");
  useEffect(() => {
    api("/events")
      .then((r) => setEvents(r.events))
      .catch((e) => setError(e.message));
  }, []);
  const visible = events.filter((event) =>
    `${event.name} ${event.location || ""}`
      .toLowerCase()
      .includes(query.toLowerCase()),
  );
  const live = events.filter((event) =>
    ["open", "paused"].includes(event.status),
  );
  const waiting = events.reduce(
    (sum, event) => sum + (event.waitingCount || 0),
    0,
  );
  return (
    <div className="business-page manage">
      <div className="page-heading">
        <div>
          <div className="eyebrow">LISTINGS / WORKSPACE</div>
          <h1>Queues that feel under control.</h1>
          <p className="muted">
            Create public listings, monitor demand, and open a live queue in one
            click.
          </p>
        </div>
        <Link className="button" to="/manage/events/new">
          <Plus size={18} /> Create listing
        </Link>
      </div>
      {error && <Banner tone="error">{error}</Banner>}
      <div className="overview-stats listing-stats">
        <div>
          <span>All listings</span>
          <strong>{events.length}</strong>
          <small>Across this workspace</small>
        </div>
        <div>
          <span>Live now</span>
          <strong>{live.length}</strong>
          <small>Open or paused queues</small>
        </div>
        <div>
          <span>Waiting customers</span>
          <strong>{waiting}</strong>
          <small>Across every listing</small>
        </div>
      </div>
      <div className="list-toolbar">
        <div className="search-field">
          <Search size={17} />
          <input
            value={query}
            onChange={(event) => setQuery(event.target.value)}
            placeholder="Search listings or locations"
          />
        </div>
        <span className="toolbar-note">
          <Activity size={16} /> Updated from your workspace
        </span>
      </div>
      {visible.length ? (
        <div className="event-list">
          {visible.map((e) => (
            <Link
              className="manage-event listing-card"
              key={e.id}
              to={"/manage/events/" + e.id + "/queue"}
            >
              <div className="listing-card-main">
                <div className="listing-card-icon">
                  <Store size={19} />
                </div>
                <div>
                  <div className="listing-card-meta">
                    <Pill value={e.status} />
                    <span>{e.operatingHours || "Hours not set"}</span>
                  </div>
                  <h2>{e.name}</h2>
                  <p>
                    <MapPin size={14} /> {e.location || "Location not set"}
                  </p>
                </div>
              </div>
              <div className="listing-card-side">
                <strong>{e.waitingCount || 0}</strong>
                <span>waiting</span>
              </div>
              <ArrowRight />
            </Link>
          ))}
        </div>
      ) : (
        <div className="empty">
          <Filter size={28} />
          <h2>
            {query
              ? "No listings match that search."
              : "Create your first listing."}
          </h2>
          <p>
            {query
              ? "Try a different name or location."
              : "Give customers a public place to find and join your queue."}
          </p>
          <Link className="button" to="/manage/events/new">
            Create listing
          </Link>
        </div>
      )}
    </div>
  );
}

export default Events;

